
const DashboardLayouts = []
DashboardLayouts['CLINICIAN_DASHBOARD'] = {
    title: '',
    widgets: [{
        type: 'Alerts'
    }, {
        type: 'Calendar'
    }, {
        type: 'Messages'
    }, {
        type: 'ToDo'
    }]
}
DashboardLayouts['PATIENT_DASHBOARD'] = {
    title: '',
    widgets: [{
        type: 'Questionnaires'
    }, {
        type: 'Calendar'
    }, {
        type: 'Messages'
    }, {
        type: 'ToDo'
    }
    ]
}
DashboardLayouts['ADMIN_DASHBOARD'] = {
    title: '',
    widgets: [{
        type: 'Calendar'
    }, {
        type: 'Messages'
    }, {
        type: 'ToDo'
    }]
}
DashboardLayouts['SYS_ADMIN_DASHBAORD'] = {
    title: '',
    widgets: [{
        type: 'Calendar'
    }, {
        type: 'Messages'
    }, {
        type: 'ToDo'
    }]
}
DashboardLayouts['HOME'] = {
    title: '',
    widgets: [{
        type: 'Questionnaires',
        permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance']
    }, {
        type: 'Profile',
        permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance']
    }, {
        type: 'Consent',
        permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance']
    }, {
        type: 'Alerts',
        permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance']
    }, {
        type: 'Messages',
        permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance']
    }, {
        type: 'ToDo',
        permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance']
    }, {
        type: 'Calendar',
        permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance']
    },
    ]
}
export default DashboardLayouts